import './Truncate-030d5f52.css';

var classes = {"Truncate":"prc-Truncate-Truncate-A9Wn6"};

export { classes as default };
